import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { context } from 'bookingbug-core-js';

@Injectable({
  providedIn: "root",
})
export class ApiService {
  private apiServer = (window.location.hostname == 'localhost') ? 'http://localhost:4201' : 'https://api.bookinglab.co.uk';
  private token = 'd9a8ae8f05419f520d443bacec2a862163821d05ce1e31678e873e70106e16be';

  constructor(private http: HttpClient) { }

  async cancelBooking(bookingId, company) {
    const headers = { 'Content-Type': 'application/json', 'X-BL-TOKEN': `${this.token}`};
    const body = {
      "host": `${context.apiUrl}`,
      "company_id": `${company.id}`,
      "cancelBookingData": {
        "notify": false,
        "booking": {
          "id": bookingId
        }
      }
    }
    return this.http.post(`${this.apiServer}/cancelBooking`, body, { headers }).toPromise();
  }

  async cancelBookings(bookingId, company) {
    const headers = { 'Content-Type': 'application/json', 'X-BL-TOKEN': `${this.token}`};
    const body = {
      "host": `${context.apiUrl}`,
      "company_id": `${company.id}`,
      "booking_id": `${bookingId}`
    }
    return this.http.post(`${this.apiServer}/cancelMultiBookings`, body, { headers }).toPromise();
  }

  async getIpAddress() {
    return this.http.get('https://api.ipify.org?format=json').toPromise();
  }

  async logPaymentRequest(company, service, bookingId, amount) {
    const headers = { 'Content-Type': 'application/json', 'X-BL-TOKEN': `${this.token}`};

    const clientAdrr = await this.getIpAddress();

    const body = {
      "host": `${context.apiUrl}`,
      "company_id": `${company.id}`,
      "service_id": `${service.id}`,
      "order_id": `${bookingId}`,
      "amount": `${amount}`,
      "client_addr": `${ clientAdrr['ip'] }`,
      "user_agent": navigator.userAgent,
      "client_os": navigator.platform,
      "provider": "elavon",
      "type": "req"

    };
    return this.http.post(`${this.apiServer}/logPayment`, body, { headers }).toPromise();
  }

  async logPaymentResponse(company, service, bookingId, responseObj) {
    const headers = { 'Content-Type': 'application/json', 'X-BL-TOKEN': `${this.token}`};

    const clientAdrr = await this.getIpAddress();

    const body = {
      "host": `${context.apiUrl}`,
      "company_id": `${company.id}`,
      "service_id": `${service.id}`,
      "order_id": `${bookingId}`,
      "provider": "elavon",
      "client_addr": `${ clientAdrr['ip'] }`,
      "response_obj": JSON.stringify(responseObj),
      "type": "res"
    };
    return this.http.post(`${this.apiServer}/logPayment`, body, { headers }).toPromise();
  }

  async logPaymentExtra(company, service, bookingId, extraObj) {
    const headers = { 'Content-Type': 'application/json', 'X-BL-TOKEN': `${this.token}`};

    const clientAdrr = await this.getIpAddress();

    const body = {
      "host": `${context.apiUrl}`,
      "company_id": `${company.id}`,
      "service_id": `${service.id}`,
      "order_id": `${bookingId}`,
      "provider": "elavon",
      "client_addr": `${ clientAdrr['ip'] }`,
      "extra_obj": JSON.stringify(extraObj),
      "type": "extra"
    };
    return this.http.post(`${this.apiServer}/logPayment`, body, { headers }).toPromise();
  }

 
}